import { Pipe, type PipeTransform, inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { LanguageService } from "@services/language.service";
import type { ITranslateObject } from "../../../views-interfaces/translate-object.interface";

@Pipe({
    name: "wkTranslate",
    pure: false,
})
export class WkTranslatePipe implements PipeTransform {
    private readonly translateService = inject(TranslateService);
    private readonly languageService = inject(LanguageService);

    public transform(value: string | ITranslateObject, params?: any): string {
        if (value === null || value === undefined || value === "") return "";

        if (typeof value === "object") {
            // Fall back to the other language when the value is only translated in one of them.
            return value[this.languageService.language()] ?? value[this.languageService.fallbackLanguage()] ?? "";
        }

        return this.translateService.instant(value, params) ?? "";
    }
}
